/* eslint-disable import/prefer-default-export */
import * as React from 'react'
import type { StepProps } from '@src/components/setup.steps/models'
import * as styles from '../../setup.wizard.styl'
import * as View from '@src/components/common/view.page'
import Tabs, { Tab } from '@src/components/common/material/tabs'
import {
  Setting,
  AlertSeveritySettingKey,
  AlertSeveritySettings
} from '../../../settings/configurations'
import { map } from 'lodash'
import { AlertSeverityEnum } from '@src/endpoints/services/commonHdr.service'
import type { NotificationInfo } from '@src/endpoints/services/commonHdr.service'
import type {
  UpdateNotificationInfoReq,
  UpdateNotificationInfoResp
} from '@src/endpoints/services/tenantMgr.service'
import uuidv4 from 'uuid/v4'
import { useState } from 'react'

interface State {
  selectedTab: AlertSeveritySettingKey
}

export const AlertsConfiguration: React.FC<StepProps> = (props: StepProps) => {
  const { updateNotificationsAction, user, footerComponent, tenant } = props
  const [state, setState] = useState<State>({
    selectedTab: 'alertshigh'
  })

  function onClickTab(tab: AlertSeveritySettingKey) {
    setState({ selectedTab: tab })
  }

  function updateNotifications(
    severity: AlertSeverityEnum,
    notificationSettings: NotificationInfo,
    callback: (data?: UpdateNotificationInfoResp) => void
  ) {
    const payload: UpdateNotificationInfoReq = {
      req_hdr: { tid: uuidv4() },
      severity,
      notification_info: notificationSettings
    }
    updateNotificationsAction(payload, callback)
  }

  function getAlertsInfo(severity: AlertSeverityEnum): NotificationInfo {
    const alertInfo = tenant?.alertSettings || []
    return alertInfo.find(elem => elem.severity === severity)
  }

  function renderTabs() {
    const setingsTabs = AlertSeveritySettings
    const { selectedTab } = state
    const currentTab: Setting = setingsTabs[selectedTab]
    const tabs =
      map(setingsTabs, (tab, key) => {
        const { title } = tab
        return (
          <Tab
            classNameLabel={styles.tabLabel}
            key={key}
            value={key}
            label={title}
          />
        )
      }) || []

    return (
      <>
        <div className={styles.tabs}>
          <Tabs onChange={onClickTab} value={selectedTab}>
            {tabs}
          </Tabs>
        </div>

        {currentTab && currentTab.component && (
          <currentTab.component
            {...props}
            notificationSettings={getAlertsInfo(currentTab?.severity)}
            severity={currentTab?.severity}
            updateNotifications={currentTab?.severity && updateNotifications}
            footerComponent={currentTab?.footerComponent}
          />
        )}
      </>
    )
  }

  return (
    <View.ContentPage className={styles.alertStep}>
      {user && tenant ? renderTabs() : null}
      {footerComponent ? React.createElement(footerComponent, props) : null}
    </View.ContentPage>
  )
}
